module.exports = __webpack_public_path__ + "img/pic7.003125bf.png";